import type { SourcingEventDto } from "../../../../../../autogen/bff-api";
import { isTwoStageProcedure } from "../../../../../../common/procurement/procedure";

export const tenderValidityShown = (event: SourcingEventDto): { months: number | null; notStatedInInvitation: boolean } => {
  const publicContext = event.eventContext.type === "Public" ? event.eventContext : null;
  const invited = isTwoStageProcedure(publicContext?.procedureType) && !!publicContext?.qualificationRound?.invitation;
  const stated = event.statedTenderValidityMonths ?? null;
  const months = invited ? stated : (stated ?? publicContext?.eFormsNoticeData?.tenderValidityMonths ?? null);
  return { months, notStatedInInvitation: invited && months === null };
};
